import { render, staticRenderFns } from "./FavoriteIcon.vue?vue&type=template&id=72d5c2e1&scoped=true"
import script from "./FavoriteIcon.vue?vue&type=script&lang=ts"
export * from "./FavoriteIcon.vue?vue&type=script&lang=ts"
import style0 from "./FavoriteIcon.vue?vue&type=style&index=0&id=72d5c2e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5c2e1",
  null
  
)

export default component.exports